export enum OrderListTestIds {
  DEFAULT_CONFIRM_MODAL_BUTTON = 'order-confirm-button',
  CANCEL_ORDER_ACTION = 'order-list-cancel-action',
  FINALIZE_ORDER_ACTION = 'order-list-finalize-action',
  CANCEL_OBSERVATION_INPUT = 'order-list-cancel-observation-input',
  CANCEL_CONFIRM_BUTTON = 'order-list-cancel-confirm-button',
  FINALIZE_CONFIRM_BUTTON = 'order-list-finalize-confirm-button',
  APPROVE_CONFIRM_BUTTON = 'order-list-approve-confirm-button',
  SYNC_OFFLINE_ORDER_ACTION = 'order-list-sync-offline-order-action',
  COPY_AS_SUGGESTED_ACTION = 'order-list-copy-as-suggested-action',
  COPY_AS_DRAFT_ACTION = 'order-list-copy-as-draft-action',
  SEARCH_CODE_FIELD = 'order-list-search-code-field',
}
